/* import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../css/websiteloadpopup.css";

const specialPaths = [
  "/apnipolicysamjho",
  "/freeclaimconsultancy",
  "/registerwebinar",
];

const WebsiteloadPopup = () => {
  const { pathname, hash } = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const currentPath = pathname.toLowerCase();
    const isSpecialPath = specialPaths.includes(currentPath);
    const isHashSpecialPath = specialPaths.some(path => hash.toLowerCase().includes(path));

    if (isSpecialPath || isHashSpecialPath) {
      setShow(false);
      return;
    }

    const onHome = currentPath === "/" || currentPath === "/home";
    const onHomeWithHash = hash.toLowerCase() === "#/";
    const seen = sessionStorage.getItem("hasSeenPopup");
    if ((onHome || onHomeWithHash) && !seen) {
      const timer = setTimeout(() => {
        setShow(true);
        sessionStorage.setItem("hasSeenPopup", "true");
      }, 1000); 

      return () => clearTimeout(timer); 
    } else {
      setShow(false);
    }
  }, [pathname, hash]);

  if (!show) return null;

  const youtubeEmbedUrl = "https://www.youtube.com/embed/rBvnJomXPzc?autoplay=1&mute=1";

  return (
    <div className="websiteload-popup-overlay">
      <div className="websiteload-popup-content">
        <button
          className="websiteload-popup-close"
          onClick={() => setShow(false)}
          aria-label="Close video popup"
        >
          <i className="fas fa-times"></i>
        </button>
        <div className="websiteload-popup-video-wrapper">
          <iframe
            src={youtubeEmbedUrl}
            title="Policy Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

export default WebsiteloadPopup;
 */


import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../css/websiteloadpopup.css";

const specialPaths = [
  "/apnipolicysamjho",
  "/freeclaimconsultancy",
  "/registerwebinar",
];

const WebsiteloadPopup = () => {
  const { pathname, hash } = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    // --- START of Commented out Pop-up Display Logic ---
    /*
    const currentPath = pathname.toLowerCase();
    const isSpecialPath = specialPaths.includes(currentPath);
    const isHashSpecialPath = specialPaths.some(path => hash.toLowerCase().includes(path));

    if (isSpecialPath || isHashSpecialPath) {
      setShow(false);
      return;
    }

    const onHome = currentPath === "/" || currentPath === "/home";
    const onHomeWithHash = hash.toLowerCase() === "#/";
    const seen = sessionStorage.getItem("hasSeenPopup");
    if ((onHome || onHomeWithHash) && !seen) {
      const timer = setTimeout(() => {
        setShow(true); // This line is the one that normally makes the popup appear
        sessionStorage.setItem("hasSeenPopup", "true");
      }, 1000); 

      return () => clearTimeout(timer); 
    } else {
      setShow(false);
    }
    */
    // --- END of Commented out Pop-up Display Logic ---

    // Ensure 'show' is always 'false' to hide the popup indefinitely
    setShow(false); 
  }, [pathname, hash]);

  if (!show) return null;

  const youtubeEmbedUrl = "https://www.youtube.com/embed/rBvnJomXPzc?autoplay=1&mute=1";

  return (
    <div className="websiteload-popup-overlay">
      <div className="websiteload-popup-content">
        <button
          className="websiteload-popup-close"
          onClick={() => setShow(false)}
          aria-label="Close video popup"
        >
          <i className="fas fa-times"></i>
        </button>
        <div className="websiteload-popup-video-wrapper">
          <iframe
            src={youtubeEmbedUrl}
            title="Policy Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

export default WebsiteloadPopup;